import React from "react";
import * as PropTypes from "prop-types";

export class CC extends React.Component {
    render() {
        return <div className="container">
            <div className="copyright">
                &copy; {this.props.cc}
            </div>
            <div className="credits">
                {this.props.designedBy}
            </div>
        </div>;
    }
}

CC.propTypes = {
    cc: PropTypes.any,
    designedBy: PropTypes.any
};